<div style="padding-top:10px">
    <!-- <plotly-plot [data]="gdata" [layout]="layout"></plotly-plot> -->
    <!-- <ng-template plate-directive></ng-template> -->
</div>
